import { getDistroToken } from '../distro/lib/distroToken';

export function isAnnouncementJwtTargetAllowed(value: string): boolean {
  try {
    const parsed = new URL(value.trim());
    if (!['http:', 'https:'].includes(parsed.protocol)) return false;

    const hostname = parsed.hostname.toLowerCase().replace(/\.$/, '');
    return hostname === 'novadistro.io' || hostname.endsWith('.novadistro.io');
  } catch {
    return false;
  }
}

export function appendJwtToAnnouncementUrl(value: string, token: string): string {
  const parsed = new URL(value);
  const fragment = new URLSearchParams(parsed.hash.replace(/^#/, ''));
  fragment.set('t', token);
  parsed.hash = fragment.toString();
  return parsed.toString();
}

export async function resolveAnnouncementTarget(value: string, attachJwt: boolean): Promise<string> {
  if (!attachJwt) return value;
  if (!isAnnouncementJwtTargetAllowed(value)) {
    throw new Error('JWT links must use novadistro.io or one of its subdomains');
  }

  const token = await getDistroToken();
  return appendJwtToAnnouncementUrl(value, token);
}

export async function openAnnouncementTarget(value: string, attachJwt: boolean): Promise<void> {
  if (!attachJwt) {
    window.open(value, '_blank', 'noopener,noreferrer');
    return;
  }

  // Open synchronously so the browser recognizes this as a user-initiated popup
  // while the short-lived Distro token is being requested.
  const targetWindow = window.open('about:blank', '_blank');
  if (!targetWindow) throw new Error('Please allow pop-ups to open this announcement link');
  targetWindow.opener = null;

  try {
    const target = await resolveAnnouncementTarget(value, true);
    targetWindow.location.replace(target);
  } catch (error) {
    targetWindow.close();
    throw error;
  }
}
